// eslint-disable-next-line import/no-extraneous-dependencies
import Vue from 'vue'
import InfiniteLoading from 'vue-infinite-loading'

Vue.component('infinite-loading', InfiniteLoading)
